// global function start for slick slider 
class ResponsiveSlick {
  constructor(selector, breakpoints) {
    this.selector = selector;
    this.breakpoints = breakpoints;
    this.init = false;

    // Initialize and attach the resize event listener
    this.slickCard();
    window.addEventListener("resize", this.slickCard.bind(this));
  }

  initSlick(options) {
    $(this.selector).slick(options);
  }

  destroySlick() {
    if ($(this.selector).hasClass('slick-initialized')) {
      $(this.selector).slick('unslick');
    }
  }

  getOptionsForWidth(width) {
    for (let breakpoint in this.breakpoints) {
      if (width <= breakpoint) {
        return this.breakpoints[breakpoint];
      }
    }
    return null;
  }

  slickCard() {
    const width = window.innerWidth;
    const options = this.getOptionsForWidth(width);

    if (options) {
      if (!this.init) {
        this.init = true;
        this.initSlick(options);
      } else {
        // If the options have changed, reinitialize the slider
        this.destroySlick();
        this.initSlick(options);
      }
    } else if (this.init) {
      this.destroySlick();
      this.init = false;
    }
  }
}


const crs__slider__option = {
  5000: {
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 4,
    dots: false,
    arrows: false,
    infinite: true
  },
  1200:{
    slidesToShow: 4,
    dots: false,
    arrows: false
  },
  992:{
    slidesToShow:2,
    dots: false,
    arrows: false,
  },
  650:{
    slidesToShow:1,
    dots: false,
    arrows: false
  }
};


const crsSlider = new ResponsiveSlick(".customers-reviews-slider", crs__slider__option);

document.addEventListener("DOMContentLoaded", function () {
  const trigger = document.querySelector(".view-similar");
  const target = document.querySelector(".related-products");

  if (trigger && target) {
    trigger.addEventListener("click", function () {
      target.scrollIntoView({ behavior: "smooth" });
    });
  }
});


 
